import cn from 'classnames';
import * as React from 'react';
import { memo } from 'react';
import { Button } from 'reactstrap';
import style from './Overlay.module.scss';
export var Overlay = memo(function (_a) {
    var onClose = _a.onClose, className = _a.className, children = _a.children, _b = _a.theme, theme = _b === void 0 ? {} : _b;
    return (React.createElement("div", { className: cn(style.container, className, theme.container) },
        onClose && (React.createElement("div", { className: cn(style.close, theme.close) },
            React.createElement(Button, { color: "link", className: cn(style.close__link, theme.close__link), onClick: onClose }, "\u00D7"))),
        children));
});
//# sourceMappingURL=Overlay.js.map